import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { CreateScenarioGrant } from '../../types/scenario-modeling.types';
import { useAppMutation } from '../use-app-mutation.hook';

export const usePatchScenarioGrant = () => {
  const { mutate: updateScenarioGrant, isPending } = useAppMutation(
    [QueryKey.PATCH_SCENARIO_GRANT],
    {
      mutationFn: ({
        data,
        scenarioId,
        grantId,
      }: {
        data: CreateScenarioGrant;
        grantId: string;
        scenarioId: string;
      }) =>
        ApiService.patch(
          {
            endpoint: BackendRoute.SCENARIOS,
            routePath: [scenarioId, 'grants', grantId],
          },
          {
            body: data,
          },
        ),
    },
  );
  return { updateScenarioGrant, isPending };
};
